// Firebase-Konfiguration
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase Konfiguration
const firebaseConfig = {
  apiKey: "AIzaSyDltRM8tL2PZtulXZmEOvFeVJFyuyo3zIo",
  authDomain: "lf1-app.firebaseapp.com",
  projectId: "lf1-app",
  storageBucket: "lf1-app.firebasestorage.app",
  messagingSenderId: "759725575205",
  appId: "1:759725575205:web:2fb38d251232ce5c4783cc"
};

// Firebase initialisieren
const app = initializeApp(firebaseConfig);

// Firebase Services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();

// Google Provider Konfiguration
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Setze Persistenz auf LOCAL
setPersistence(auth, browserLocalPersistence);

// Konfiguriere Auth für E-Mail-Verifizierung
auth.useDeviceLanguage();
auth.settings = {
  appVerificationDisabledForTesting: false
};

export { auth, db, storage, googleProvider }; 